exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  padding: 0;\n  color: #FFFFFF;\n  font-size: 11px;\n  line-height: 11px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/power-planner/power-planner/src/app/page-creep-level.module/power-resource-needed.component/power-resource-needed.component.scss
// module id = ../../../../../src/app/page-creep-level.module/power-resource-needed.component/power-resource-needed.component.scss
// module chunks = main